import { render, staticRenderFns } from "./HotelServiceDetail.vue?vue&type=template&id=7e1b147e&scoped=true"
import script from "./HotelServiceDetail.vue?vue&type=script&lang=js"
export * from "./HotelServiceDetail.vue?vue&type=script&lang=js"
import style0 from "./HotelServiceDetail.vue?vue&type=style&index=0&id=7e1b147e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1b147e",
  null
  
)

export default component.exports